/**
 * Secret Admin Stats Screen — shows usage analytics.
 * Accessible only via a hidden gesture (tapping the title 7 times).
 */

import { navigate } from '../router';
import { connect, sendMessage, onServerEvent, disconnect } from '../ws-client';
import { ServerMessage } from '../../shared/protocol';

export function renderAdminStats(): void {
  const app = document.getElementById('app')!;

  app.innerHTML = `
    <div class="stack center">
      <h1>📊 Stats</h1>
      <p class="subtitle" id="stats-status">Connecting...</p>

      <div class="surface" id="stats-container" style="display:none;">
        <div class="final-scores">
          <div class="final-score-team">
            <div class="score-label">Unique Users</div>
            <div class="score-value" id="stat-users">—</div>
          </div>
          <div class="final-score-team">
            <div class="score-label">Games Played</div>
            <div class="score-value" id="stat-games">—</div>
          </div>
        </div>
      </div>

      <button class="btn btn-tertiary" id="btn-back">Back</button>
    </div>
  `;

  document.getElementById('btn-back')?.addEventListener('click', () => {
    disconnect();
    navigate('menu');
  });

  // Connect and request stats
  fetchStats();
}

async function fetchStats(): Promise<void> {
  const statusEl = document.getElementById('stats-status');
  const containerEl = document.getElementById('stats-container');

  try {
    await connect();

    // Listen for the stats response
    const unsub = onServerEvent((msg: ServerMessage) => {
      if (msg.type === 'stats-response') {
        if (statusEl) statusEl.style.display = 'none';
        if (containerEl) containerEl.style.display = '';
        const usersEl = document.getElementById('stat-users');
        const gamesEl = document.getElementById('stat-games');
        if (usersEl) usersEl.textContent = String(msg.gamesPlayed !== undefined ? (msg as any).uniqueUsers : 0);
        if (gamesEl) gamesEl.textContent = String((msg as any).gamesPlayed || 0);
        unsub();
      }
    });

    // Send the request
    sendMessage({ type: 'get-stats' });
  } catch {
    if (statusEl) statusEl.textContent = 'Failed to connect';
  }
}
